module.exports = __webpack_public_path__ + "img/sidebar-close@3x.32079aa8.png";